import "@fontsource-variable/manrope";
import "@fontsource-variable/space-grotesk";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { ToastProvider } from "./components/ui/Toast";
import { AssessmentSessionProvider } from "./features/session/AssessmentSessionContext";
import "./styles/index.css";
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <AssessmentSessionProvider>
          <ToastProvider>
            <App />
          </ToastProvider>
        </AssessmentSessionProvider>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
